import { Link } from "@tanstack/react-router";
import { useMemo } from "react";

import type { UserType } from "../../types";
import Socials from "./socials";

interface ProfileProps {
  user: UserType;
}

export default function Profile({ user }: ProfileProps) {
  const properties = useMemo(() => {
    const nameParts: string[] = [];
    const parts: string[] = [];

    if (user.firstName) {
      nameParts.push(user.firstName);
    }
    if (user.lastName) {
      nameParts.push(user.lastName);
    }
    if (user.pronouns) {
      nameParts.push(`(${user.pronouns})`);
    }
    if (nameParts.length) {
      parts.push(nameParts.join(" "));
    }
    if (user.location) {
      parts.push(user.location);
    }

    return parts.join(" | ");
  }, [user]);

  return (
    <div className="flex flex-col items-stretch gap-[3px]">
      <div className="flex h-[41px] items-center justify-between md:justify-start">
        <h1 className="font-semibold text-16 text-white md:text-24">
          <Link to={`/@${user.username}`}>{user.username}</Link>
        </h1>
        <Socials
          facebookUrl={user.facebookUrl}
          instagramUrl={user.instagramUrl}
          tiktokUrl={user.tiktokUrl}
          twitterUrl={user.twitterUrl}
        />
      </div>
      {!!properties && (
        <p className="text-13 text-pale-lavender leading-[1.5em] md:text-15">
          {properties}
        </p>
      )}
      {!!user.websiteUrl && (
        <p className="text-13 leading-[1.5em] md:text-15">
          <a
            className="text-berry hover:underline"
            href={user.websiteUrl}
            rel="noopener noreferrer"
            target="_blank"
          >
            {user.websiteUrl}
          </a>
        </p>
      )}
    </div>
  );
}
